// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__BtETa","content":"styles_content__3ciOI","selectAll":"styles_selectAll__2tSW-"};